var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiltArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F0F2F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1605_12726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1605_12726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 23.0003L12.167 21.8337L20.167 13.8337H13.0003V12.167H23.0003V22.167H21.3337V15.0003L13.3337 23.0003Z",
    fill: "#878787"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiltArrow);
export default __webpack_public_path__ + "static/media/TiltArrow.919521d107113c121b1ed5e3e42ee5a9.svg";
export { ForwardRef as ReactComponent };